export default "__VITE_ASSET__ac2b213b__"